module.exports = __webpack_public_path__ + "logo.b815817cdd83572d349dfcc84af133f6.png";